<template lang="pug">
  v-window(
    v-model="step"
  )
    v-window-item
      .d-flex.align-center(v-if="modules.items.length")
        v-chip(color="grey lighten-4" large)
          v-avatar(color="secondary" dark): strong.white--text 1
          span.ml-2 Шаг

        div.ml-4 Ваш курс использует модули, заполните соглашения на использование этих модулей

      v-fade-transition(leave-absolute)
        v-skeleton-loader(
          v-if="modules.loading"
          type="list-item-two-line@5"
        ).my-4.sdo-radius
      v-card(
        v-for="moduleItem in modules.items"
        :key="moduleItem.id"
        outlined
        color="grey lighten-4"
      ).my-4.sdo-radius
        v-card-text
          .title.mb-3 {{ moduleItem.name }}
          v-item-group(v-model="modules.selectedConfig[moduleItem.id]")
            v-row.mb-5
              v-col
                v-item(
                  :value=`{
                    id: moduleItem.id,
                    price_per_user: moduleItem.price_per_user,
                    price_escort_per_user: moduleItem.price_escort_per_user,
                    is_pricing: true,
                    is_escorted: false,
                  }`
                  v-slot="{ active, toggle }"
                )
                  v-card(
                    :color="active ? 'secondary' : 'white'"
                    :dark="active"
                    flat
                    @click="toggle"
                  ).d-flex.align-center.justify-center.sdo-card.fill-height
                    .text-center
                      v-icon(:color="active ? 'white' : 'secondary'" size=100) mdi-account-off
                      .grey--text Без сопровождения
                      p {{ moduleItem.price_per_user }} ₽
              v-col
                v-item(
                  :value=`{
                    id: moduleItem.id,
                    price_per_user: moduleItem.price_per_user,
                    price_escort_per_user: moduleItem.price_escort_per_user,
                    is_pricing: false,
                    is_escorted: true,
                  }`
                  v-slot="{ active, toggle }"
                )
                  v-card(
                    :color="active ? 'secondary' : undefined"
                    :dark="active"
                    flat
                    :disabled="moduleItem ? !moduleItem.user_special_conditions.is_escorted : false"
                    @click="toggle"
                  ).d-flex.align-center.justify-center.sdo-card.fill-height
                    .text-center
                      v-icon(:color="active ? 'white' : 'secondary'" size=100) mdi-account
                      template(
                        v-if="moduleItem ? moduleItem.user_special_conditions.is_escorted : false"
                      )
                        .grey--text С сопровождением
                        p {{ moduleItem.price_escort_per_user }} ₽
                      template(v-else)
                        .grey--text Сопровождение недоступно
                        v-icon mdi-lock-outline
          v-checkbox(
            v-model="modules.agrees[moduleItem.id]"
            color="secondary"
            label="Согласен с условиями использования модуля и ценой"
          )
      .d-flex
        v-spacer
        v-btn(
          :disabled="!canContinue"
          color="secondary"
          @click="step += 1"
        ).px-5 Продолжить

    v-window-item
      // Заголовок
      .mb-5
        template(v-if="!modules.items.length")
          h2 Создание набора
        .d-flex.align-center(v-else)
          v-chip(color="grey lighten-4" large)
            v-avatar(color="secondary" dark): strong.white--text 2
            span.ml-2 Шаг

          div.ml-4 Завершите создание набора

      api-form(
        v-model="form"
        :fields="fields"
        :method="save"
        :btn-props=`{
          btnText: 'Создать набор',
        }`
      )
</template>

<script>
import HintWrap from '@/components/HintWrap.vue';

export default {
  name: 'EnrollmentForm',
  props: {
    courseId: { type: [Number, String], required: true },
  },
  data: () => ({
    step: 1,
    modules: {
      items: [],
      loading: false,
      selectedConfig: {},
      agrees: {},
    },
    form: {},
    fields: [
      {
        text: 'Начало набора',
        value: 'period_start',
        rules: 'required',
        component: HintWrap,
        component_attrs: {
          component: 'sdo-datetime-field',
          'label-date': 'Начало набора',
          hintDescription: 'Даты, с которых набор виден для записи',
          'only-date': true,
          type: 'number',
        },
      },
      {
        text: 'Окончание набора',
        value: 'period_end',
        rules: 'required',
        component: 'sdo-datetime-field',
        component_attrs: {
          'label-date': 'Окончание набора',
          'only-date': true,
          type: 'number',
        },
      },
      {
        text: 'Начало обучения',
        value: 'start_learning',
        rules: 'required',
        component: HintWrap,
        component_attrs: {
          component: 'sdo-datetime-field',
          'label-date': 'Начало обучения',
          hintDescription: 'Планируемые даты проведения обучения',
          'only-date': true,
          type: 'number',
        },
      },
      {
        text: 'Окончание обучения',
        value: 'end_learning',
        rules: 'required',
        component: 'sdo-datetime-field',
        component_attrs: {
          'label-date': 'Окончание обучения',
          'only-date': true,
          type: 'number',
        },
      },
      {
        text: 'Количество мест',
        value: 'number_place',
        rules: 'required',
        component: HintWrap,
        component_attrs: {
          component: 'v-text-field',
          hintDescription: 'Указывается максимальное число обучающихся на этот набор',
          filled: true,
          rounded: true,
          type: 'number',
        },
      },
    ],
  }),
  computed: {
    allAgrees() {
      return Object.values(this.modules.agrees).every((i) => !!i);
    },
    allSelectedModules() {
      return Object.values(this.modules.selectedConfig).length === this.modules.items.length;
    },
    canContinue() {
      return !this.modules.loading && this.allSelectedModules && this.allAgrees;
    },
  },
  created() {
    this.fetchModules();
  },
  methods: {
    async fetchModules() {
      this.modules.loading = true;
      const { items } = await this.$api.modules.index({
        expand: 'user_status,user_special_conditions',
        'search[user_id]': this.$user.data.id,
        'search[course_id]': this.courseId,
      });
      this.modules.items = items;
      this.modules.loading = false;

      if (items.length) this.step -= 1;
      items.forEach((i) => {
        this.$set(this.modules.agrees, i.id, false);
      });
    },
    async save({ data, obs }) {
      const payloads = {
        ...data,
        course_modules: Object.values(this.modules.selectedConfig),
      };
      const resp = await this.$api.enrollments.createEnrollment(
        payloads, this.courseId, obs,
      );
      const enrollmentId = resp.data.data.id;
      await this.$api.telegram.enrollmentChannel(enrollmentId);

      this.$router.replace({
        name: 'CourseEnrollmentView',
        params: { id: this.courseId, enrollmentId },
      });
    },
  },
};
</script>
